import React, {
  type ReactNode,
  createContext,
  useContext,
  useState,
} from 'react';
import { colors } from '../../lib/colors';
import { type DesignTokens, tokens } from '../../lib/tokens';

type LegacyThemeType = typeof colors;

interface ThemeContextType {
  theme: {
    colors: LegacyThemeType;
  };
  tokens: DesignTokens;
}

const ThemeContext = createContext<ThemeContextType>({
  theme: { colors },
  tokens,
});

export const useTheme = (): ThemeContextType => {
  return useContext(ThemeContext);
};

export const ThemeProvider = ({
  children,
}: {
  children: ReactNode;
}): React.JSX.Element => {
  const theme = colors;

  const [currentTheme] = useState(theme);

  return (
    <ThemeContext.Provider
      value={{
        theme: { colors: currentTheme },
        tokens,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
